import React from 'react';
import ReactDOM from 'react-dom';

import './styles.scss';

class University extends React.Component {

  ScrollToAction = RefID => event => {
    const node = ReactDOM.findDOMNode(this.refs[RefID]);

    if (node) {
      node.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  }

  render() {
    return (
      <div className='container'>
        <div className="row">
          <div className="col-md-3">
            <ul className='UnviersityScroller'>
              <li onClick={this.ScrollToAction('Introduction')}>Introduction</li>
              <li onClick={this.ScrollToAction('Quickstart')}>Quickstart</li>
              <li onClick={this.ScrollToAction('CodeConduct')}>Code of Conduct</li>
              <li onClick={this.ScrollToAction('GreatCoach')}>What makes a great coach</li>
              <li onClick={this.ScrollToAction('CoachingModules')}>Coaching Modules</li>
              <li onClick={this.ScrollToAction('SampleClips')}>Sample Session Clips</li>
              <li onClick={this.ScrollToAction('DeveloperCoaching')}>Further Develop your Coaching</li>
              <li onClick={this.ScrollToAction('FAQ')}>Frequently Asked Questions</li>
            </ul>
          </div>
          <div className="col-md-9">
            <h3 ref='Introduction'>Introduction</h3>
            <p>
              We’re thrilled to welcome you onboard as a Paragon One Advisor. Rest assured - you’re in good company. You join a diverse network of hand-selected, high-achieving professionals from the finest companies in the United States.
        </p>
            <p>
              Paragon One is a one-of-a-kind online career accelerator. Founded in 2015 by former MIT classmates and serial online entrepreneurs Matt Wilkerson and Byron Hsu, Paragon One provides a network of hundreds of students with personalized career coaching to accelerate them from interests and passion to internship and job offers.
        </p>
            <p>
              We rely on Advisors like you to deliver this experience. Your advice, encouragement, and support will empower students with the know-how to pursue their dream careers and succeed. As such, we’ve created this guide to help you communicate effectively the expertise and decades of industry knowledge that you have to share.
        </p>
            <p>
              We look forward to working with you, and welcome to the Paragon One Advisor Network.
        </p>
            <br />
            <br />
            <h3 ref='Quickstart'>Quick Start</h3>
            <h5>You’re an Advisor - now what?</h5>
            <p>
              Congratulations and welcome to the Paragon One family. Using our proprietary matching system that marries the human element with data, our team is working to pair you with a student to begin advising sessions as soon as possible. We ask that you sign the Code of Conduct and complete additional fields in your profile for us to better match you with students.
        </p>
            <h5>Advising Flowchart</h5>
            <img style={{ maxWidth: '100%' }} src="/images/AdvisingFlowChart.png" alt="Advising Flowchart" />

            <h5>Set Up Zoom</h5>
            <p>
              All of Paragon One sessions are conducted over the video software Zoom. When you have been matched with a student for a session, you will receive a Zoom link in the email calendar invite that will automatically start the software to begin your session.
        </p>
            <p>
              Here is the link to install Zoom: <a href="https://zoom.us/download">https://zoom.us/download</a>
            </p>
            <br />
            <br />
            <h3 ref='CodeConduct'>Expectations & Code of Conduct</h3>
            <p>
              Universities do not prepare students for finding jobs. Our mission at Paragon One is to bridge this gap and to help students pursue their dream careers. We rely on our advisors to provide insightful knowledge and feedback, and to ensure that our students receive the best possible experience for starting their careers. Towards that end, we have laid the following expectations:
        </p>
            <p>
              <b>Paragon One Mission:</b> We have one goal - to give back to the student community by empowering young minds with the tools and knowledge needed to succeed. Our team depends on you advisors in delivering the support and encouragement for students to be able to pursue their careers, and we hope that you convey our mission through your sessions.
        </p>
            <p>
              <b>Commitment:</b> We understand that your schedule is extremely busy. For that reason, Paragon One has no restrictions on how many sessions you choose to hold each month, or how many hours you put into the coaching program. However, we hope advisors will stay active (on a bi-monthly / quarterly basis) by partaking in coaching sessions, webinar talks, or other events.
        </p>
            <p>
              <b>Preparation:</b> Prior to each session, the Paragon One team will send information regarding the student you have been paired with, and the learning module for the session. We ask that you look over the material provided, and do any pre-session preparation work necessary.
        </p>
            <p>
              <b>Timeliness:</b> We ask that advisors be settled in and ready for the call about 10 minutes before the start time so that it can begin on time.
        </p>
            <p>
              <b>Cancellation Policy:</b> We understand that unexpected events can pop up anytime. If you have to cancel your scheduled session with a student, we ask that you provide alternative times within 24-48 hours.
        </p>
            <p>
              <b>Community Conduct:</b> You are now part of the Paragon One Advisory Network, consisting of hundreds of professionals hailing from over 25 industries. We ask that you:
        </p>
            <ol>
              <li>Treat everyone with dignity and respect</li>
              <li>Be inclusive and considerate</li>
              <li>Be thoughtful and careful with your words</li>
              <li>Be honest and forthcoming</li>
            </ol>
            <br /><br />

            <h3 ref='GreatCoach'>Characteristics of a Great Coach</h3>
            <p>We’ve all had dozens of teachers and professors from our days in school. Yet we only remember a hand-full of them - only the ones who have made a huge impact on us. What differentiated the great teachers? What did they do that helped your course of learning? As a Paragon One Advisor, you will be working with students of all ages, backgrounds, and nationalities. From past student feedback, we’ve put together this list of common qualities of a great career coach:</p>
            <hr />

            <p><b>Give Detailed and Insightful Advice</b></p>
            <p>The students who sign up for Paragon One’s services are looking for tailored, specific, and comprehensive information about certain industries that might not otherwise be available on the Internet. Not all students have the same understanding of your industry or job vertible - but don’t be afraid to dig deep!</p>
            <hr />

            <p><b>Deliver Structured and Planned Sessions</b></p>
            <p>Many of our past students have expressed the desire for advisors to take the reign of session agenda and to deliver on clear objectives. You can still be flexible in planning the focus of each module in order to make room for students to ask questions, but it is very important that you convey a clear direction and significant takeaways. One common mistake in the past is for advisors to start the session by asking the student: “what do you want to talk about today?”</p>
            <hr />

            <p><b>Have a Clear Opinion - but Stay Open-Minded</b></p>
            <p>Our ultimate objective is to guide students to be able to make the best decisions for themselves. That said, each session is their chance to learn from your years of experience and the wisdom you have accumulated over the years. Although you may not feel 100% certain in the advice you give, you should feel confident that it is an extremely valuable perspective.  So don’t be afraid to be decisive in your feedback - while still listening to the student and staying open minded at the same time.</p>
            <hr />

            <p><b>Be Open to Sharing</b></p>
            <p>One of the most effective ways to build trust is to share your beliefs and values. You can do so by sharing your background and stories (without straying off subject), which can give students an extremely intimate experience, as well as the key to piecing together your choices. Getting to know you as a person will add context to your lessons.</p>
            <hr />

            <p><b>Communicating with International Students</b></p>
            <p>Many of our students are few thousand miles away from home. They face more challenges than students who were born and raised in the US. It significant helps students better understand your message when you speak slowly, and avoid acronyms and slang expressions when possible. Some students can be very shy, and will need time and encouragement to warm up.</p>
            <hr />
            <br /><br />

            <h3 ref='CoachingModules'>Coaching Modules</h3>
            <p>The Paragon One team has broken down every step of job hunting. To help you better plan and engage with students, we’ve created modules based on each of these steps of career searching. Each one caters to the need of students, and has a specific objective and tangibles any student should be able to walk away with.</p>
            <br />
            <table className='table table-striped'>
              <thead>
                <tr>
                  <th>Module</th>
                  <th>Objective</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    Career Exploration
              </td>
                  <td>
                    Help your student explore different career options. Offer insights to your own industry and career path, and help determine what might be a good fit for the student.
              </td>
                </tr>
                <tr>
                  <td>
                    Job Target and Search Strategy
              </td>
                  <td>
                    Help your student explore job and internship opportunities in your industry. Guide them on where to look, and share strategies that will help them land interviews.              </td>
                </tr>
                <tr>
                  <td>
                    Resume Deep Dive
              </td>
                  <td>
                    Help the student craft a resume. By the end of the session, the student should have a resume ready for submission.
              </td>
                </tr>
                <tr>
                  <td>
                    Cover Letter Deep Dive
              </td>
                  <td>
                    Help the student craft a cover letter. By the end of the session, the student should have a cover letter ready for submission.
              </td>
                </tr>
                <tr>
                  <td>
                    LinkedIn Deep Dive
              </td>
                  <td>
                    Help the student craft a LinkedIn profile. By the end of the session, the student should have a professional LinkedIn Profile.
              </td>
                </tr>
                <tr>
                  <td>
                    Storytelling | Self Introduction
              </td>
                  <td>
                    Help the student craft a self introduction and elevator pitch. By the end of the session, the student should have a versatile self intro script to use for networking purposes.
              </td>
                </tr>
                <tr>
                  <td>
                    Mock Interviews
              </td>
                  <td>
                    Help the student improve his or her interviewing skills by asking a list of questions that are unique to your industry, and demonstrating what makes a great response.
              </td>
                </tr>
                <tr>
                  <td>
                    Hard Skill Development
              </td>
                  <td>
                    This is a three session mentorship module to help the student learn and improve a technical skill necessary for landing an internship or job in your field.
              </td>
                </tr>
                <tr>
                  <td>
                    Soft Skill Development
              </td>
                  <td>
                    This is a three session mentorship module to help the student learn and improve a soft skill necessary for landing an internship or job in your field.
              </td>
                </tr>
              </tbody>
            </table>
            <br /><br />
            <h3 ref='SampleClips'>Sample Session Clips</h3>
            <p>All of Paragon One’s advisory sessions are held digitally over a program called Zoom. It is very similar to a Skype or Google Hangouts call. Here are short clips of previous sessions with advisors to let you get a feel of how sessions are conducted.</p>
            <table>
              <tbody>
                <tr>
                  <td style={{ padding: '5px' }}>
                    <b>Tatiana Becker:</b><br />
                    <a href="https://paragonone.wistia.com/medias/h3895ceqm1">
                      What is your top recommendation on how to network and get referrals?
                </a>
                    <br />
                  </td>
                  <td style={{ padding: '5px' }}>
                    <b>Amy Wu:</b><br />
                    <a href="https://paragonone.wistia.com/medias/1wv3dlhw31">
                      4 Skills that need to be developed in order to match the basic requirement of each job
                </a>
                    <br />
                  </td>
                </tr>
                <tr>
                  <td style={{ padding: '5px' }}>
                    <b>Ada Glover:</b><br />
                    <a href="https://paragonone.wistia.com/medias/rryk9m9bzl">
                      How do I choose an internship that perfectly fits me?
                </a>
                    <br />
                  </td>
                  <td style={{ padding: '5px' }}>
                    <b>Melody Ko:</b><br />
                    <a href="https://paragonone.wistia.com/medias/ioqphg5dzv">
                      How should recent college graduates choose between big companies or startups?
                </a>
                    <br />
                  </td>
                </tr>
                <tr>
                  <td style={{ padding: '5px' }}>
                    <b>June Zheng advising Tiffany Zhang:</b><br />
                    <a href="https://app.paragonone.com/recordings/109-199637458-a8f6d92e-048d-4beb-88a5-efc3502558b0">
                      Career Exploration in Data Science
                </a>
                    <br />
                  </td>
                  <td style={{ padding: '5px' }}>
                    <b>Matt Wilkerson advising Tim Zhi:</b><br />
                    <a href="https://app.paragonone.com/recordings/34-125576892-e65e3e2e-d514-4a3b-bcc7-b47c75f080e2">
                      Career Exploration in Investment Banking
                </a>
                    <br />
                  </td>
                </tr>
              </tbody>
            </table>
            <br /><br />
            <h3 ref='DeveloperCoaching'>Further Develop Your Coaching Skills</h3>
            <p>Looking for more? Here are some tools from other prominent leaders and career coaches on how to improve your coaching and teaching.</p>
            <hr />
            <p><b>What Makes a Good Teacher Great?</b></p>
            <p>Azul Terronez breaks down how communication and language, the tools for conveying trust and reaching students, are the essential keys for a great teacher to stand out.</p>
            <a href="https://www.youtube.com/watch?reload=9&v=vrU6YJle6Q4">View</a>
            <hr />
            <p><b>Building Trust and Conveying Your Beliefs</b></p>
            <p>Simon Sinek’s “Start with Why” offers valuable insight to phrasing your pitch, and how to shape and construct your story in a such a way that builds trust, and emphasizes exactly what you stand for.</p>
            <a href="https://www.ted.com/talks/simon_sinek_how_great_leaders_inspire_action">View</a>
            <hr />
            <p><b>How to Speak so that People Want To Listen</b></p>
            <p>Julian Treasure breaks down the “7-Deadly Sins of Speaking,” a list of habits that we should avoid in order to become powerful speakers and build trust.</p>
            <a href="https://www.ted.com/talks/julian_treasure_how_to_speak_so_that_people_want_to_listen">View</a>
            <hr />
            <p><b>5 Ways to Listen Better</b></p>
            <p>We retain only about 25% of what we hear - why is that? Julian Treasure breaks down how our brains interprets sound, and how intent can be utilized to allow us to better focus on what we are hearing.</p>
            <a href="https://www.ted.com/talks/julian_treasure_5_ways_to_listen_better">View</a>
            <hr />
            <p><b>10 Ways to Have a Better Conversation</b></p>
            <p>Every conversation can devolve into an argument - it is so easy to come to disagreement, and people have been the most polarized than ever in history. Celeste Headlee highlights some strategies to balance talking and listening to improve our ability to have a great conversation.</p>
            <a href="https://www.ted.com/talks/celeste_headlee_10_ways_to_have_a_better_conversation">View</a>
            <hr />
            <p><b>The Power of Vulnerability</b></p>
            <p>Brene Brown ties how vulnerability and shame will affect an individual’s courage and therefore authenticity in their connections and relationships with others. Her studies illustrated how these four attributes will determine a person’s ability to communicate and be compassionate to themselves and others around them.</p>
            <a href="https://www.ted.com/talks/brene_brown_on_vulnerability?referrer=playlist-when_you_re_having_a_hard_time">View</a>
            <hr />
            <br /><br />
            <h3 ref='FAQ'>Frequently Asked Questions</h3>
            <hr />
            <p><b>You’re an advisor - what now?</b></p>
            <p>Welcome to the family! Our team is working to pair you with a student to begin advising sessions as soon as possible. Once we find a student matching your profile, you will receive an email notification to schedule your session, as well as which coaching module* you will be leading. In the meantime, you can:</p>
            <ol>
              <li>Complete your profile</li>
              <li>Get involved in the community</li>
              <li>Go through the supplement training material</li>
            </ol>
            <p>*For more information on coaching modules, <a href="#" onClick={this.ScrollToAction('CoachingModules')}>click here.</a></p>
            <hr />
            <p><b>Who will I be advising?</b></p>
            <p>Paragon One works primarily with college and graduate students, but we are expanding to young professionals as well. Many of these individuals are international students from Asia and Europe who are currently completing their higher degree in the United States.</p>
            <hr />
            <p><b>How are sessions conducted?</b></p>
            <p>All our sessions are done online through the video software Zoom. You can conduct sessions from the comfort of your home or any quiet location with Internet access. For every session, you will need only a computer* with a webcam, the Zoom software, and stable Internet connection.</p>
            <p>*While you can use Zoom on your phone, a computer is preferred.</p>
            <hr />
            <p><b>How I be evaluated on my performance during the sessions?</b></p>
            <p>You will be evaluated on your communication ability and how much impact your advice and session had on the student. After completing each session, students are given a survey to reflect on the meeting, and also to leave any feedback on how you might improve your coaching. Your average coaching scores will be reflected on the dashboard for you to see.</p>
            <hr />
            <p><b>What if I am running late or have to cancel last minute?</b></p>
            <p>We understand that expected things can pop up at work and in life. If you expect to be late or need to cancel last minute, please contact our team directly to reschedule. We also provide a means to anonymously text each other for last-minute adjustments.</p>
            <hr />
            <p><b>What if the student cancels last minute?</b></p>
            <p>We know that your time is extremely valuable. If a student cancels within 2 hours of the session, you will still be compensated for the session, and we will help reschedule for another time.</p>
            <hr />
            <p><b>How will I get paid?</b></p>
            <p>Advisors are compensated for each coaching session. Please fill in your payment information or a donation preference on your profile page. You should expect to receive your payment 2-3 weeks after completing a session.</p>
            <hr />
            <h6>Any more questions? Contact <a href="mailto:advisor@paragonone.com">advisor@paragonone.com</a> for other information.</h6>
            <br />
            <br />
            <p>For any questions on scheduling or coaching, please contact:</p>
            <p>
              <b>Alice Shin | Director of Education</b>
              <br />
              <a href="mailto:alice@paragonone.com">alice@paragonone.com</a>
            </p>
            <br />
            <p>For any technical inquiries, please contact:</p>
            <p>
              <b>Byron Hsu | CTO</b>
              <br />
              <a href="mailto:byron@paragonone.com">byron@paragonone.com</a>
            </p>
          </div>
        </div>
      </div>
    )
  }
}

export default University;


// WEBPACK FOOTER //
// ./src/routes/advisor/routes/University/routes/University/components/University/index.js